import { render, staticRenderFns } from "./ModalProductSpec.vue?vue&type=template&id=b0a5da96&scoped=true&"
import script from "./ModalProductSpec.vue?vue&type=script&lang=js&"
export * from "./ModalProductSpec.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductSpec.vue?vue&type=style&index=0&id=b0a5da96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a5da96",
  null
  
)

export default component.exports